import React, { createContext, useState } from 'react';

export const AuthContext = createContext();

export function AuthProvider({ children }) {
  /* ── safely initialise from localStorage ─────────────────────────── */
  let initialUser = null;
  try {
    const raw = localStorage.getItem('user');
    if (raw) initialUser = JSON.parse(raw);
  } catch {
    console.warn('Corrupted user JSON ⇒ clearing');
    localStorage.removeItem('user');
  }

  const [user, setUser] = useState(initialUser);

  /* ── helper: login (store token + user) ──────────────────────────── */
  const login = ({ token, user: userData }) => {
    localStorage.setItem('token', token);
    localStorage.setItem('user', JSON.stringify(userData));
    setUser(userData);
  };

  /* ── helper: logout (remove auth keys only) ──────────────────────── */
  const logout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
}
